// Dutch plurals are written out, chosen from the number. "asset(s)", "regel(s)"
// and "taak/taken" are developer shorthand and have no business on a screen an
// owner reads.
export const plural = (n, one, many) => `${n} ${Number(n) === 1 ? one : many}`;
